import { getBrandName, getBrandNameLimited } from '../utilities/branding';

export const sectionWrapperContent = {
  assumptions: '<p>Read about our <a href="https://dev1-author.pru.local/editor.html/content/pru-co-uk/homepage/pensions-retirement/approaching-retirement/Retirement-Planner-Assumptions.html">assumptions</a> and what our estimate is based on.</p>',
  ageLabel: 'What age are you?',
  ageTooltip: '<p>Some helpful information about:</p><br/><p>What age are you?</p>',
  scottishTaxPayerLabel: 'Are you a Scottish Tax Payer?',
  stillPayingLabel: 'Are you still paying into your pension?',
  stillPayingTooltip: '<p>Some helpful information about:</p><br/><p>Are you still paying into your pension?</p>',
  totalValueLabel: 'What is the total value of your pension pot?',
  totalValueTooltip: '<p>Some helpful information about:</p><br/><p>What is the total value of your pension?</p>',
  withdrawalAgeLabel: 'What age would you want to start withdrawing money?',
  withdrawalAgeTooltip: '<p>Some helpful information about:</p><br/><p>What age would you start to withdraw from your pension pot?</p>',
  neededMoneyLabel: 'How much do you think you need to live on annually?',
  neededMoneyTooltip: '<p>Some helpful information about:</p><br/><p>How much money do you think you would need to live on?</p>',
  incomeLabel: 'What is your income before tax?',
  incomeTooltip: '<p>Some helpful information about:</p><br/><p>Annual income</p>',
  employeeContributionLabel: 'How much do you currently pay into your pension?',
  employeeContributionTooltip: '<p>Some helpful information about:</p><br/><p>% of your salary you pay in each month</p>',
  employerContributionLabel: 'How much does your employer currently pay into your pension?',
  employerContributionTooltip: '<p>Some helpful information about:</p><br/><p>% your employer pays in each month</p>',
  employerContributionPlaceholder: 'Enter amount (optional)',
  plansSubsectionTitle: 'Tell us about your retirement plans',
  contributionsSubsectionTitle: 'Tell us about your contributions',
  agePlaceholder: 'Enter age',
  buttonText: 'Show results',
};

export const inputContent = {
  textInputPlaceholder: 'Enter amount',
  dropdownInputPlaceholder: 'Open...',
};

export const errors = {
  isRequired: 'isRequired',
  isNumber: 'isNumber',
  isInteger: 'isInteger',
  isMoreThan0: 'isMoreThan0',
  isFiftyFiveOrMore: 'isFiftyFiveOrMore',
  isEighteenOrMore: 'isEighteenOrMore',
  isEightyOrLess: 'isEightyOrLess',
  isOneHundredOrLess: 'isOneHundredOrLess',
  isLessThanOneMillion: 'isLessThanOneMillion',
  isTenMillionOrLess: 'isTenMillionOrLess',
  isDateValid: 'isDateValid',
  isOver18: 'isOver18',
  isAfter1900: 'isAfter1900',
  isInThePast: 'isInThePast',
  isPercentage: 'isPercentage',
  isEqualOrMoreThanCurrentAge: 'isEqualOrMoreThanCurrentAge',
};

export const outputContent = {
  introHeading: 'What will you do with your pension pot?<br/>Let’s explore your options.',
  assumptions: 'Please read all our <a href="https://www.mandg.com/pru/customer/retirement-planning/tools-calculators/rsr-drawdown-change-income/assumptions" target="_blank" data-test="ppc-outputs-link-assumptions">assumptions</a> to see how the figures below have been calculated. In particular we use long term inflation rates which may be higher or lower than current rates of inflation and we don’t take into account any other sources of income such as salary or State Pension. This means you could end up paying a higher rate of income tax depending on your personal circumstances. The figures below are based on your pot being worth',
  sliderHeader: 'How we arrived at this figure',
  todaysPricesTooltip: 'Over time, the price of goods and services goes up. This is because of inflation. We’ve reduced your forecasted figures, to account for inflation, so that you can see how much your money could be worth today.',
  mediumReturnTooltip: 'The way markets perform over the years will affect how your money grows. We look at a thousand different possible outcomes - most of these fall into a middle ground so it is more likely that you will have an amount that is between the high return and low return. To be more specific, there is a 50% chance of getting the medium value. However, there is a 5% chance of getting more than the high return or less than the low return. Try sliding the range of possible returns bar to see what could happen to your money if you received more or less than the medium value.',
  taxFreeLumpSum: 'Take 25% as a tax-free lump sum',
  backButton: 'Edit and re-calculate',
  guaranteedIncomeBox: {
    heading: 'Guaranteed income',
    guaranteedIncome: 'With a guaranteed annual income of',
    forLife: 'for life',
    bodyText: '<br/>You could get a higher or lower income if any of the above conditions are changed.<br/>Any income will be taxed like a salary.',
    linkText: 'Find out more about <a href="https://www.mandg.com/pru/customer/en-gb/retirement-planning/approaching-retirement" target="_blank" data-test="ppc-outputs-link-guaranteed-income">guaranteed income.</a>',
  },
  flexibleIncomeBox: {
    heading: 'Flexible cash or income',
    dipInto: 'Then either dip into the remaining',
    leavingTheRest: 'as and when you need it while leaving the rest invested.',
    takeAnnual: 'Take an annual income of',
    bodyText: 'The income option shown increases in line with Retail Price Index (RPI) each year.',
    linkText: 'Find out more about <a href="https://www.mandg.com/pru/customer/en-gb/retirement-planning/approaching-retirement" target="_blank" data-test="ppc-outputs-link-flexible-income">taking it as cash.</a>',
  },
  cashBox: {
    heading: 'Take it as cash',
    remaining: 'The remaining 75% is taxed, leaving',
    plusTaxFree: 'plus your tax-free lump sum to take home',
    incomeTax: 'Paying minimum Income Tax of',
    cashInfo: 'Take your cash in stages, with the first 25% of each withdrawal being tax-free. The remaining 75% is taxed as income.',
    linkText: 'Read more about <a href="https://www.mandg.com/pru/customer/en-gb/retirement-planning/approaching-retirement" target="_blank" data-test="ppc-outputs-link-cash-options">cash options.</a>',
  },
  combinationBox: {
    heading: 'Combination of options',
    bodyText: 'You can combine the options available to you.You could for example, use some of your pension pot to take cash and use the rest to set up a guaranteed income (annuity) or a drawdown. You can usually get 25% tax-free from each option, although you must take this from the options you choose at the start.And if you’ve got more than one pension, you can choose different options for each one.',
    linkText: 'Find out more about <a href="https://www.mandg.com/pru/customer/en-gb/retirement-planning/approaching-retirement" target="_blank" data-test="ppc-outputs-link-combination">a combination of options.</a>',
  },
  leaveItBox: {
    heading: 'Leave it where it is',
    bodyText: 'Choose how to take your money when the time is right for you.You don’t have to do anything with your pension pot now. If you don’t need your money now, you can leave it invested in your plan.Keep paying into your pension plan and continue to benefit from tax relief.',
    linkText: 'Read more about <a href="https://www.mandg.com/pru/customer/en-gb/retirement-planning/approaching-retirement" target="_blank" data-test="ppc-outputs-link-leaving-where-it-is">leaving your pension where it is.</a>',
  },
  needAdvice: {
    heading: 'Need Advice',
    // tslint:disable-next-line:max-line-length
    get bodyText() {
      const brand = getBrandName();
      return `If you do not already have a financial adviser, ${brand} can help. Whatever your aspirations, ${brand} have access to a range of pension funds to help you achieve the lifestyle you want in retirement.<br/>Find out more about <a href="https://www.mandg.com/wealth/advice?adlt=strict" target="_blank" data-test="ppc-need-advice-link"> ${brand}.</a>`;
    },
  },
  thingsToConsider: {
    heading: 'Things to consider',
    bodyTextBold: 'The actual amount you receive will depend on the type of pension you have, your circumstances, how much your pension pot grows by and the rates available at the time you take your money out, which could be higher or lower than the amounts shown.<br/><br/>With all investments, the value of your investment can go down as well as up so you might get back less than you put in.',
    bodyText: '<strong>Small pension pots</strong><br/>If your pension pot is below £10,000, you may be able to take the whole pot as a small lump sum. You can usually do this up to three times and each payment you take must not exceed £10,000. The first 25% of each payment will usually be tax-free with the rest subject to income tax.<br/><br/><strong>How long your money will last</strong><br/>You will need to think about how you will make your pension pot last in retirement.  If you take out too much and/or the returns on your investments are lower than you expect, you could run out of money earlier than you think.  You will then need to rely on other sources of income, such as the State Pension, to fund your lifestyle in retirement.<br/><br/><strong>Shop around</strong><br/>When deciding what to do with your pension pot you should be aware that different providers offer different products that may be more suited to your individual circumstances. Each product option could also have different tax implications. Their rates, investment funds, charges and terms may also be different.<br/><br/>For example, with an annuity they might use different criteria to assess you or your partner’s health and/or lifestyle conditions, this is often called an enhanced annuity. This might mean that you could get a higher level of income elsewhere.<br/><br/>This is why it’s important to shop around - so that whatever you decide to do, it’s the right decision for you.',
  },
  nextStep: {
    title: 'What next?',
    intro: 'If you want to chat about your options, our dedicated team are here to help answer any questions you might have.',
    phone: '0345 640 2000',
    openingTimes: 'Lines are open Monday to Friday, 9am to 5pm',
    numberInfo: 'This is your unique reference number. Please make a note of it and be sure to have it handy if you decide to call us.',
    numberLabel: 'Unique reference number:',
    numberLoading: 'Loading...',
    numberError: 'An error has occured, we’re unable to generate your number.',
    // tslint:disable-next-line:max-line-length
    get infoBox() {
      return `If you\u2019re unsure about your options please speak to your financial adviser. If you don\u2019t have an adviser, you can find one at unbiased.co.uk or you could speak to ${getBrandNameLimited()}.`;
    },
  },
};

export const analytics = {
  revealOutput: 'Retirement Planner tool - reveal output',
  editInput: 'Retirement Planner tool - edit input',
  stillPaying: 'Retirement Planner tool - Still Paying',
};


export enum Country {
  UK = 'Rest of UK',
  Scotland = 'Scotland'
}

export enum Plan {
  PCP = 'Pension Choices Plan',
  FRP = 'Flexible Retirement Plan',
  RA = 'Retirement Account',
  IDK = 'I don’t know',
}

export enum Gender {
  Male = 'Male',
  Female = 'Female',
}

export enum Frequency {
  Monthly = 'Monthly',
  Yearly = 'Yearly',
}

export enum IsCash {
  Yes = 'Yes',
  No = 'No',
}

// Warning: changing FMC and Growth values may break calculator and calculatorHelpers tests
export const FMCs = {
  [IsCash.No]: 1.35,
  [IsCash.Yes]: 1.00,
};

export const growths = {
  [IsCash.No]: 5.0,
  [IsCash.Yes]: 0,
};




// WEBPACK FOOTER //
// ./src/content/content.ts